import {ClassicType} from "../../shared/models/ClassicType";

export class Corriere {
  id?: number;
  nominativo?: string;
  link?:string;
  tipi?: number[];
  username?: string;
  password?: string;
  test?: boolean;
  key?: string;
  modifica?: boolean;
  tipiObject?: ClassicType[];
  enabled?: boolean;
  ritiro?: boolean;
  triangolazione?: boolean;
  internazionale?: boolean;
  nazionale?: boolean;
  assicurazione?: boolean;
  contrassegno?: boolean;
  trackingLaera?: boolean;
}
